// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database'; // nếu dùng Realtime Database
import { getAuth } from 'firebase/auth'; // nếu dùng Authentication
console.log(" Firebase đã được khởi tạo");
const firebaseConfig = {
 apiKey: "AIzaSyAJSlLv3-LxG2FvXATzivaZlrKKTyMTceU",
  authDomain: "vuejs-cb0f7.firebaseapp.com",
  databaseURL: "https://vuejs-cb0f7-default-rtdb.firebaseio.com",
  projectId: "vuejs-cb0f7",
  storageBucket: "vuejs-cb0f7.appspot.com",
  messagingSenderId: "422783484607",
  appId: "1:422783484607:web:807c56bdbdaeb8e1c63c0a",
  measurementId: "G-247N50KPPP"
};

// Khởi tạo Firebase
const app = initializeApp(firebaseConfig);

// Khởi tạo dịch vụ
const database = getDatabase(app);
const auth = getAuth(app);

export { database , auth };
